import { render, staticRenderFns } from "./SalviMusicShopWhiteLogo.vue?vue&type=template&id=78305a2a&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports